module.exports = __webpack_public_path__ + "img/nowgg_store.79b713e.png";